import { createMachine, assign, actions } from "xstate";
import { CaseCreationType } from "src/types";

interface Context {
  name: string;
  description: string;
  userSrid: string;
  caseType: CaseCreationType;

  // TODO: refactor once normal case is added
  polygon_frontendSrid: string;
}

type CaseCreateEvent =
  | { type: "PREVIOUS" }
  | { type: "CREATE_NORMAL" }
  | { type: "CREATE_PREDEFINED"; payload: Context }
  | { type: "NEXT"; payload: Context }
  | { type: "PREVIOUS" }
  | { type: "CREATION_SUCCESS" };

const context: Context = {
  name: "",
  description: "",
  userSrid: "",
  caseType: CaseCreationType.PREDEFINED,
  polygon_frontendSrid: "",
};

export const caseCreateMachine = createMachine<Context, CaseCreateEvent>({
  id: "caseCreate",
  initial: "new",
  context: context,
  states: {
    new: {
      on: {
        PREVIOUS: {
          actions: ["exit"],
        },
        CREATE_NORMAL: {
          target: "normal",
        },
        CREATE_PREDEFINED: {
          target: "predefined",
          actions: assign((context: Context, event) => {
            return { ...context, ...event.payload };
          }),
        },
      },
    },
    normal: {
      initial: "step1",
      states: {
        step1: {
          type: "final",
          on: {
            PREVIOUS: "#caseCreate.new",
            NEXT: "#caseCreate.submitting",
          },
        },
      },
    },
    predefined: {
      initial: "step1",
      states: {
        step1: {
          type: "final",
          on: {
            PREVIOUS: "#caseCreate.new",
            NEXT: {
              target: "#caseCreate.submitting",
              actions: assign((context: Context, event) => {
                return { ...context, ...event.payload };
              }),
            },
          },
        },
      },
    },
    submitting: {
      entry: actions.choose([
        {
          cond: (context) => context.caseType === CaseCreationType.NORMAL,
          actions: ["submitNormal"],
        },
        {
          cond: (context) => context.caseType === CaseCreationType.PREDEFINED,
          actions: ["submitPredefined"],
        },
      ]),
      on: {
        CREATION_SUCCESS: "created",
      },
    },
    created: {
      type: "final",
      exit: ["exit"],
    },
  },
});
